declare let window: any;
window.Vue = Vue;

// essas variáveis são do 'anti-robo' que fica fora do escopo vue no index.html
// precisa ficar lá para carregar antes de tudo e conseguir registrar a entrada na página o mais cedo possível
// depois são usadas no erviço TemporalCountService;
const url = window.solucx_temporal_url ?? '';
const debug_id = window.solucx_temporal_debug_id ?? '0';
const key = window.solucx_temporal_key ?? '';

import Vue from 'vue';
import App from './App.vue';
import VueI18n from 'vue-i18n';
import i18n, { applyDocumentLanguage } from '@/services/Setupi18n';

import router from './router';

import { BButton, BAlert, BFormGroup, BFormInput, BFormTextarea, BButtonGroup, BFormRadio, BFormRadioGroup, BSpinner } from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { FontAwesomeIcon } from '@/plugins/fontawesome';

Vue.component('b-button', BButton);
Vue.component('b-alert', BAlert);
Vue.component('b-form-group', BFormGroup);
Vue.component('b-form-input', BFormInput);
Vue.component('b-form-textarea', BFormTextarea);
Vue.component('b-button-group', BButtonGroup);
Vue.component('b-form-radio', BFormRadio);
Vue.component('b-form-radio-group', BFormRadioGroup);
Vue.component('b-spinner', BSpinner);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueI18n);

import ServiceInitializer from '@/services/ServiceInitializer';
import BaseService from './services/BaseService';
import LocationService from './services/LocationService';
import TemporalCountService from './services/TemporalCountService';
import TurnstileService from './services/TurnstileService';
import { shouldInitializeTurnstile } from './helpers/shouldInitializeTurnstile';

Vue.config.productionTip = false;

main();
function main() {
    const locationService = new LocationService(location);
    const services: Record<string, BaseService> = new ServiceInitializer().init(locationService.instanceToken);

    Vue.component('treeselect', Treeselect);

    applyDocumentLanguage();

    new Vue({
        render: h => h(App),
        router,
        i18n,
        data: {
            instanceName: null,
        },
        provide: {
            ...services,
            turnstileService: shouldInitializeTurnstile(globalThis.location.search) ? new TurnstileService(process.env.VUE_APP_TURNSTILE_SITE_KEY) : null,
            temporalCountService: new TemporalCountService({ url, debug_id, key, timeToCount: 60, tolerance: 3, delay: 5 }),
        },
    }).$mount('#app');
}
